import { createContext, useContext } from "react";

export const ThemeModeContext = createContext({
  mode: "light" as "light" | "dark",
  toggleMode: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);
